// extracted by mini-css-extract-plugin
export default {"order-dropdown":"AgsF5","orderDropdown":"AgsF5"};